import React from 'react';

export function AssignmentCompletedSVG({ className = '' }: { className?: string }) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 14L11 16.5L16 11"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5 22H19C20.1046 22 21 21.1046 21 20V8L15 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22Z"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M15 2V6C15 7.10457 15.8954 8 17 8H21"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
}
